// extracted by mini-css-extract-plugin
export var bg = "DataSecurityWithMediaAside-module--bg--0d59b";
export var content = "DataSecurityWithMediaAside-module--content--2db1d";
export var grid = "DataSecurityWithMediaAside-module--grid--249be";